(function($) {
  var imageWhidth,
      imageheight;

  /**
   * Resive the cover on publications to be 100% large everytime.
   * @return void
   */
  function resizeCover()
  {
    var windowWidth = $(window).width() + 40; // width + 2*20 for blur overflow.

    if (windowWidth >= 768) {
      var topOffset = (windowWidth >= 992) ? '-23%': '-12%';
      $('.cover-blurred img').css({
        left: '-20px',
        top: topOffset,
        width : windowWidth,
        height : (windowWidth * imageheight ) / imageWhidth
      });
    } else {
      $('.cover-blurred img').css({
        left: (windowWidth - imageWhidth) / 2,
        top: '-20px', // Just hides the blur overflow effect.
        width: imageWhidth,
        height: imageheight
      });
    }
  }

  $(document).ready(function() {
    var image = new Image();
    var initialLeft = '-80px';
    var pos = 0;
    if ($('.couch-container').length > 0) {
      pos = $('.couch-container').offset().left - 80 + 'px';
    }
    var $cover = $('.cover-blurred img');

    var initAffix = function() {
      if ($cover) {
        imageWhidth = $('.cover-blurred img').width();
        imageheight = $('.cover-blurred img').height();
      }
      if ($('.couverture').length > 0) {
        $('.rs-widget').affix({
          offset: {
            top: $('.couverture').offset().top + $('.couverture').outerHeight(true) + 30
          }
        });
      }

      if ($('.rs-widget').hasClass('affix')) {
        $('.rs-widget').css({left: pos});
      }

      $('.rs-widget').on('affixed.bs.affix', function(e) {
        $(this).css({left: pos});
      });
      $('.rs-widget').on('affixed-top.bs.affix', function(e) {
        $(this).css({left: initialLeft});
      });
      $('.rs-widget').on('affixed-bottom.bs.affix', function(e) {
        $(this).css({left: initialLeft});
      });
    };

    if ($cover.length > 0) {
      image.onload = initAffix;
      image.src = $cover.attr('src');
    } else {
      // Init affix.
      initAffix();
    }

    $(window).bind('resize', function() {
      resizeCover();
      if ($('.couch-container').length > 0) {
        pos = $('.couch-container').offset().left - 80 + 'px';
      }
    });
    resizeCover();
  });
})(jQuery);
